module.exports = __webpack_public_path__ + "static/media/circles-loader.1cbd2e08.svg";